import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getLetterHeader(params) {
	return clientSupplier.get("api-supplier/letter/header", {
		params: params,
	});
}

export default {
	getLetterHeader,
};